import React from "react";

const SelfLogo: React.FC = () => {
  return <img src="/logo-no-background.png" alt="Savar-Jain" className="mb-4 w-1/4" />;
};

export default SelfLogo;
